module.exports = __webpack_public_path__ + "img/icon-certified.36bbf2d6.svg";